import React from 'react';
import styled from 'styled-components';

export const RadioButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 5px;
`;